import request from '@hb/sharp-request';
import { gatewayUrl } from '@/constant';

// 根据哈啰用户token获取金融用户登录信息
export const getFinanceUser = (
  token: string,
  baseURL?: string,
  source?: string,
  platformFirstLogin?: number, // 1 首次登录，0 非首次登录
): Promise<NativeModel.FinanceUserData> => request.postGate(
  'f.user.loginByTripGw',
  {
    token,
    source,
    platformFirstLogin,
  },
  {
    baseURL: baseURL || gatewayUrl,
    withCredentials: false,
    standardResponse: false,
    showLoading: undefined,
    showErrMsg: undefined,
  },
);

export default getFinanceUser;
